var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"switch"},[_c('input',{class:{ checked: _vm.value, disabled: _vm.disabled },attrs:{"type":"checkbox"},on:{"input":_vm.UpdateValue}}),_c('span',{staticClass:"slider"})])}
var staticRenderFns = []

export { render, staticRenderFns }